/**
 * http配置
 */
// 引入axios以及element ui中的loading和message组件
import axios from 'axios'
import Promise from 'promise'
import {Loading} from 'element-ui'
import Constants from '../components/Constants'
// http请求拦截器
var loadingInstace;
let needLoadingRequestCount = 0;
axios.interceptors.request.use(config => {
  // element ui Loading方法

  if(sessionStorage.getItem(Constants.ACCESS_TOKEN)){
    config.headers = {
      "accessToken": sessionStorage.getItem(Constants.ACCESS_TOKEN)
      // "accessToken": "0cfcb0699c734d59a770ee76d09183ee" //给华夏组件提供固定的token
    }
  }
  if (config['showLoading']) {
    // loadingInstace = Loading.service({fullscreen: true})
    showFullScreenLoading();
  }
  return config
}, error => {
  tryHideFullScreenLoading();
  return Promise.reject(error)
});
// http响应拦截器
axios.interceptors.response.use(response => {// 响应成功关闭loading
  if(response.config['showLoading']){
    tryHideFullScreenLoading();
  }
  // closeLoading();
  return response
}, error => {
  tryHideFullScreenLoading();
  return Promise.reject(error)
});

function closeLoading() {
  if (loadingInstace) {
    loadingInstace.close();
  }
}
function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    loadingInstace = Loading.service({fullscreen: true,background:"#ffffff4f"})
  }
  needLoadingRequestCount++
}

function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    closeLoading()
  }
}
export default axios



// WEBPACK FOOTER //
// ./src/interceptors/ajax.interceptor.js